import { FunctionComponent } from 'react'

import { Icon, IIconProps } from 'native-base'
import { Path } from 'react-native-svg'

type Props = IIconProps & { size?: number }

export const AlertIcon34: FunctionComponent<Props> = ({ size, ...props }) => {
  const originalWidth = 20.0

  const originalHeight = 14.0

  const maxDim = Math.max(originalWidth, originalHeight)

  const scale = size ? size / maxDim : 1

  const width = originalWidth * scale

  const height = originalHeight * scale

  return (
    <Icon viewBox="0 0 20 14" width={width} height={height} {...props}>
      <Path
        d="M16.079 0C17.113 0 18.053 0.400001 18.754 1.054C18.79 1.076 18.823 1.104 18.853 1.136C18.873 1.158 18.891 1.181 18.906 1.205C19.584 1.91 20 2.86701 20 3.92101V10.109C20 12.258 18.258 14 16.109 14H3.89101C1.74201 14 0 12.258 0 10.109V3.92101C0 1.75601 1.75601 0 3.92101 0H16.079ZM12.52 7.642L11.328 8.741C10.571 9.415 9.43001 9.41499 8.66701 8.73499L7.48 7.642L1.996 12.293C2.464 12.699 3.06299 12.957 3.72099 12.995L3.89101 13H16.109C16.834 13 17.497 12.733 18.005 12.292L12.52 7.642ZM1.565 2.194C1.21 2.677 1 3.27501 1 3.92101V10.109C1 10.619 1.132 11.099 1.364 11.515L6.739 6.95901L1.565 2.194ZM18.437 2.198L13.262 6.95999L18.636 11.514C18.842 11.145 18.969 10.725 18.995 10.279L19 10.109V3.92101C19 3.27701 18.791 2.681 18.437 2.198ZM16.079 1H3.92101C3.31601 1 2.753 1.184 2.286 1.5L9.339 7.99399C9.716 8.32999 10.285 8.33 10.656 8L17.717 1.502C17.249 1.185 16.686 1 16.079 1Z"
        fill="#4775FF"
      />
    </Icon>
  )
}
